export { default as ListarTipoProducto} from './Listar'
export { default as TipoProductoCrear  } from './Crear'
